export default {
    path: '/detail',
    meta: {
        title: "详情"
    },
    component: () => import('@/views/imgList/imgList')
}